"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.switchRender = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

// import
// definition
var switchRender = function switchRender(_ref) {
  var isTrue = _ref.isTrue,
      render = _ref.render,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["isTrue", "render", "children"]);
  return isTrue ? render(children, props) : children;
};

exports.switchRender = switchRender;

var main = /*#__PURE__*/_react["default"].memo(function Switch(props) {
  var children = switchRender(props);
  if (!children) return null;
  if (children instanceof Array) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  return children;
});

main.displayName = "Switch"
var _default = /*#__PURE__*/main;
exports["default"] = _default;